import React, { PropsWithChildren } from 'react'

const CalculatorContainer = ( { children }:Props ) => {

  return (
    <div className="container mx-auto">
      { children }
    </div>
  )
}

interface Props extends PropsWithChildren<any>{}

export { CalculatorContainer }
